// Classic › sale (#1119): the ticket sale page and the tickets index. The
// buyer fields' labels and placeholders are site-core's (pages.sale.buyer).
import { plural } from '../../../plural'

const en = {
  /** A missing or unpublished sale. */
  notFound: {
    title: 'Ticket Sale Not Found',
    body: "This sale doesn't exist, or it's no longer available.",
    allTickets: 'All Tickets',
  },
  /** The hero image's alt text. */
  heroAlt: (title: string) => `${title} hero`,
  about: 'About',
  event: 'Event',
  when: 'When',
  where: 'Where',
  closed: 'Sales for this event have closed.',
  noTypes: 'No tickets configured yet.',
  /** Low-stock pill. */
  left: (n: number | null) => `${n} left`,
  soldOut: 'Sold out',
  /** Online price vs the door price; only the saving is shown. */
  doorSavings: (amount: string) => `Save ${amount} vs at the door`,
  quantityFor: (name: string) => `Quantity for ${name}`,
  decrease: (name: string) => `Decrease ${name} quantity`,
  increase: (name: string) => `Increase ${name} quantity`,
  yourOrder: 'Your order',
  ticketCount: (n: number) => plural(n, { one: '# ticket', other: '# tickets' }),
  noneSelected: 'No tickets selected yet.',
  continueToCheckout: 'Continue to checkout',
  /** The phone bar's short form. */
  continue: 'Continue',
  buyerForm: 'Buyer information',
  back: 'Back',
  /** The pay button while the checkout session is being created. */
  paying: 'Loading…',
  payWithCard: 'Pay with card',
  /** The tickets index (/tickets). */
  index: {
    intro: 'Grab your seat for upcoming events.',
    emptyTitle: 'No Tickets On Sale',
    emptyBody: 'Check back soon for upcoming events.',
    cardLabel: (title: string) => `Get tickets for ${title}`,
    /** The big letter on a card with no image (the sale title's first letter wins). */
    cardInitial: 'T',
    /** `{price}` is the cheapest ticket, rendered in its own element. */
    fromPrice: 'From {price}',
    getTickets: 'Get Tickets',
  },
}

export default en
